import React, {useState, useEffect, useRef} from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link } from 'react-router-dom';
import PosthogFilterDropdown from "./PosthogFilterDropdown";

const DesktopTabsForWebsiteAnalytics= ({setActiveTab, activeTab, setFilterOpen, filterOpen, filters, setFilters, onApply, handleResetFilters}) => {

    const filterWrapperRef = useRef(null);
   
    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isClickInsideWrapper =
            filterWrapperRef.current &&
            filterWrapperRef.current.contains(event.target);
        
            const isClickInsideDatePicker =
            event.target.closest(".MuiPickersPopper-root");
        
            if (!isClickInsideWrapper && !isClickInsideDatePicker) {
            setFilterOpen(false);
            }
        };
        
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="flex w-full h-[280px] justify-center items-center 
           bg-[linear-gradient(89deg,_#8772DC_0%,_#7EEFFF_100%)]"
            >
           <div className="w-[80%] h-fit flex flex-col gap-[50px] mt-[80px]">
                <p className="text-[45px] font-bold text-[#FFFFFF] mt-[20px]"> 
                    Visitor Intelligence Hub
                </p>
                
                <div className="w-full flex justify-between items-end">
                    <div className="flex gap-[90px] ">
                        <div className="flex flex-col gap-[2px] cursor-pointer">
                            <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                            onClick={() => {
                                setActiveTab("Live Feed");
                            }}
                            >
                                Live Feed
                            </p>
                            { activeTab === "Live Feed" && (
                                <div className="h-[7px] bg-[#FFFFFF]">
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col gap-[2px] cursor-pointer">
                            <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                            onClick={() => {
                                setActiveTab("Archive");
                            }}
                            >
                                Archive
                            </p>
                            { activeTab === "Archive" && (
                                <div className="h-[7px] bg-[#FFFFFF]">
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col gap-[2px] cursor-pointer">
                            <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                            onClick={() => {
                                setActiveTab("Country");
                            }}
                            >
                                Country
                            </p>
                            {activeTab === "Country" && (
                                <div className="h-[7px] bg-[#FFFFFF]">
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex gap-[20px] relative">
                        {/* Filter Button + Dropdown */}
                        <div className="relative" ref={filterWrapperRef}>
                            <button
                            className="w-[180px] h-[45px] flex justify-center items-center text-[19px] text-[#FFF] gap-[5px]"
                            style={{
                                background: 'transparent linear-gradient(90deg, #8774DC 0%, #80D2F6 51%, #8776DD 100%) 0% 0% no-repeat padding-box',
                                boxShadow: '0px 3px 6px #00000029',
                                borderRadius: '6px'
                            }}
                            onClick={() => setFilterOpen((prev) => !prev)}
                            >
                                <span>Filter History</span>
                                <span>
                                    {filterOpen ? (
                                    <KeyboardArrowDownIcon style={{ fontSize: "20px", color:"#FFF" }} />
                                    ) : (
                                    <ArrowForwardIosIcon style={{ fontSize: "16px", color:"#FFF" }} />
                                    )}
                                </span>
                            </button>

                            {/* Dropdown */}
                            {filterOpen && (
                                <div className="absolute right-0 top-[50px] z-50">
                                    <PosthogFilterDropdown  filters={filters} setFilters={setFilters} onApply={onApply} handleResetFilters={handleResetFilters} activeTab={activeTab} /> 
                                </div>
                            )}  
                        </div>
                    </div>

                </div>
           </div>
        </div>
    );
};

export default DesktopTabsForWebsiteAnalytics;
